import getCurrentEnvironment from '../envUtils';

const useMultiFactorAuthentication = () => {
  const isProduction = getCurrentEnvironment() === 'production';
  const enabled = isProduction || process.env.NEXT_PUBLIC_FORCE_DISABLE_MFA !== 'true';

  return { enabled };
};

export { useMultiFactorAuthentication };
